import React from 'react'
import { ViewPropTypes } from 'react-native'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import SelectInput from '../SelectInput'
import { initSelector } from '../../redux/initReducer/initSelector'

const TimeZoneSelect = (props) => {
  const { name, selected, onChange, icon, multiselect, label, style, readonly } = props

  const { timeZones, loadTimeZone } = useSelector(initSelector)

  return (
    <SelectInput
      name={name}
      label={label}
      selected={selected}
      onChange={onChange}
      icon={icon}
      placeholder='Timezone'
      multiselect={multiselect}
      keyProp='timezone_id'
      nameProp='name'
      options={timeZones}
      loading={loadTimeZone}
      containerStyle={style}
      readonly={readonly}
      getOptionLabel={(timezone) => timezone ? `${timezone.name}, ${timezone.abbreviation}, ${timezone.offset}` : '--'}
    />
  )
}

TimeZoneSelect.propTypes = {
  name: PropTypes.string,
  selected: PropTypes.any,
  icon: PropTypes.string,
  onChange: PropTypes.func,
  multiselect: PropTypes.bool,
  style: ViewPropTypes.style,
  label: PropTypes.string,
  readonly: PropTypes.bool
}

TimeZoneSelect.defaultProps = {
  name: '',
  selected: null,
  icon: '',
  onChange: () => {},
  multiselect: false,
  readonly: false
}

export default TimeZoneSelect
